if (!customElements.get('filters-sidebar-toggle')) {
  customElements.define(
    'filters-sidebar-toggle',
    class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;

        const targetId = this.button.getAttribute('aria-controls');
        this.panel = targetId ? document.getElementById(targetId) : null;
        if (!this.panel) return;

        this.storageKey = 'filters-sidebar-collapsed';

        const stored = sessionStorage.getItem(this.storageKey);
        this.setCollapsed(stored === 'true');

        this.button.addEventListener('click', () => {
          const isCollapsed = this.panel.classList.contains('hidden');
          this.setCollapsed(!isCollapsed);
          sessionStorage.setItem(this.storageKey, String(!isCollapsed));
        });
      }

      setCollapsed(collapsed) {
        this.panel.classList.toggle('hidden', collapsed);
        this.button.setAttribute('aria-expanded', String(!collapsed));
        this.classList.toggle('filters-sidebar-toggle--collapsed', collapsed);

        const wrapper = this.panel.closest('.collection-wrapper');
        if (wrapper) {
          wrapper.classList.toggle('filters-sidebar-collapsed', collapsed);
        }
      }
    }
  );
}
